import ExamSelectors from '../components/ora/Global/ExamSelectors/ExamSelectors';
import McGrawHillMapButton from './McGrawHillMapButton';
import McGrawHillModeToggle from './McGrawHillModeToggle';
import { useMcGrawHillMode } from './mcgrawHillModeStore';

/**
 * mcgraw-hill (ORA-1265): a member's selector slot at the top of the AI
 * desktop. The Clinical / Study toggle, the knowledge map's button, and in
 * Study the exam pill. A Clinical turn uses no exam, so its pill would only
 * mislead.
 */
const McGrawHillDesktopSelectors = () => {
  const mode = useMcGrawHillMode();

  return (
    <div className="flex items-center gap-2">
      <McGrawHillModeToggle />
      <McGrawHillMapButton />
      {mode === 'study' && <ExamSelectors variant="header" />}
    </div>
  );
};

export default McGrawHillDesktopSelectors;
